export default function(videojs) {
	// from https://github.com/videojs/video.js/issues/4460#issuecomment-312861657
	const SeekBar = videojs.getComponent(`SeekBar`)

	SeekBar.prototype.getPercent = function getPercent() {
		// Allows for smooth scrubbing when player can't keep up
		const time = this.player_.currentTime()
		const percent = time / this.player_.duration()
		return percent >= 1 ? 1 : percent
	}

	SeekBar.prototype.handleMouseMove = function handleMouseMove(event) {
		let newTime = this.calculateDistance(event) * this.player_.duration()
		if (newTime === this.player_.duration()) {
			newTime = newTime - 0.1
		}
		this.player_.currentTime(newTime)
		this.update()
	}

	// override hiding mouseTimeDisplay on mobile
	SeekBar.prototype.options_.children.splice(1, 0, `mouseTimeDisplay`)

	const ProgressControl = videojs.getComponent(`ProgressControl`)

	class MobileProgressControl extends ProgressControl {
		enable() {
			super.enable()
			this.on(this.el_, `touchmove`, this.handleMouseMove)
		}
		disable() {
			super.disable()
			this.off(this.el_, `touchmove`, this.handleMouseMove)
		}
	}

	videojs.registerComponent(`ProgressControl`, MobileProgressControl)
}
